// @generated by protoc-gen-es v2.14.1 with parameter "target=ts,import_extension=js"
// @generated from file common.proto (package chessstreamlive.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common.proto.
 */
export const file_common: GenFile = /*@__PURE__*/
  fileDesc("Cgxjb21tb24ucHJvdG8SGWNoZXNzc3RyZWFtbGl2ZS5jb21tb24udjEihgEKBlB1enpsZRIKCgJpZBgBIAEoCRI5CghwbGF5YWJsZRgCIAEoCzInLmNoZXNzc3RyZWFtbGl2ZS5jb21tb24udjEuUGxheWFibGVEYXRhEjUKCHRheG9ub215GAMgASgLMiMuY2hlc3NzdHJlYW1saXZlLmNvbW1vbi52MS5UYXhvbm9teSJ9CgxQbGF5YWJsZURhdGESCwoDZmVuGAEgASgJEhEKCXNldHVwX2ZlbhgCIAEoCRISCgpzZXR1cF9tb3ZlGAMgASgJEjkKCHNlcXVlbmNlGAQgAygLMicuY2hlc3NzdHJlYW1saXZlLmNvbW1vbi52MS5Tb2x1dGlvblN0ZXAimAEKDFNvbHV0aW9uU3RlcBIMCgRtb3ZlGAEgASgJEjMKBGhpbnQYAiABKAsyJS5jaGVzc3N0cmVhbWxpdmUuY29tbW9uLnYxLlB1enpsZUhpbnQSRQoLcmVmdXRhdGlvbnMYAyADKAsyMC5jaGVzc3N0cmVhbWxpdmUuY29tbW9uLnYxLlByZWNvbXB1dGVkUmVmdXRhdGlvbiIpCgpQdXp6bGVIaW50Eg0KBW51ZGdlGAEgASgJEgwKBGlkZWEYAiABKAkiSAoVUHJlY29tcHV0ZWRSZWZ1dGF0aW9uEhYKDmF0dGVtcHRlZF9tb3ZlGAEgASgJEhcKD3JlZnV0YXRpb25fbGluZRgCIAMoCSJwCghUYXhvbm9teRIOCgZyYXRpbmcYASABKAUSDgoGdGhlbWVzGAIgAygJEhQKDG9wZW5pbmdfdGFncxgDIAMoCRIbCg5zb3VyY2VfZ2FtZV9pZBgEIAEoCUgAiAEBQhEKD19zb3VyY2VfZ2FtZV9pZCpACgVDb2xvchIVChFDT0xPUl9VTlNQRUNJRklFRBAAEg8KC0NPTE9SX1dISVRFEAESDwoLQ09MT1JfQkxBQ0sQAiqOAQoKR2FtZVJlc3VsdBIbChdHQU1FX1JFU1VMVF9VTlNQRUNJRklFRBAAEhcKE0dBTUVfUkVTVUxUX09OR09JTkcQARIZChVHQU1FX1JFU1VMVF9XSElURV9XSU4QAhIZChVHQU1FX1JFU1VMVF9CTEFDS19XSU4QAxIUChBHQU1FX1JFU1VMVF9EUkFXEAQq4gEKCU1vdmVDbGFzcxIaChZNT1ZFX0NMQVNTX1VOU1BFQ0lGSUVEEAASEwoPTU9WRV9DTEFTU19CRVNUEAESGAoUTU9WRV9DTEFTU19CUklMTElBTlQQAhITCg9NT1ZFX0NMQVNTX0dPT0QQAxIVChFNT1ZFX0NMQVNTX05PUk1BTBAEEhkKFU1PVkVfQ0xBU1NfSU5BQ0NVUkFDWRAFEhYKEk1PVkVfQ0xBU1NfTUlTVEFLRRAGEhYKEk1PVkVfQ0xBU1NfQkxVTkRFUhAHEhMKD01PVkVfQ0xBU1NfQk9PSxAIQh4KGmNvbS5jaGVzc3N0cmVhbWxpdmUuY29tbW9uUAFiBnByb3RvMw");

/**
 * The universal, stateless definition of a chess puzzle — identical across the daily
 * ladder (Play) and the Learn tab. Anonymous; safe to edge-cache. Surfaces differ only
 * by wrapper: the daily ladder is immutable content; the Learn tab adds per-user state.
 *
 * @generated from message chessstreamlive.common.v1.Puzzle
 */
export type Puzzle = Message<"chessstreamlive.common.v1.Puzzle"> & {
  /**
   * stable puzzle id "pz:<content-hash>"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * everything needed to render the board + play the line
   *
   * @generated from field: chessstreamlive.common.v1.PlayableData playable = 2;
   */
  playable?: PlayableData | undefined;

  /**
   * intrinsic metadata (matchmaking / post-solve review)
   *
   * @generated from field: chessstreamlive.common.v1.Taxonomy taxonomy = 3;
   */
  taxonomy?: Taxonomy | undefined;
};

/**
 * Describes the message chessstreamlive.common.v1.Puzzle.
 * Use `create(PuzzleSchema)` to create a new message.
 */
export const PuzzleSchema: GenMessage<Puzzle> = /*@__PURE__*/
  messageDesc(file_common, 0);

/**
 * @generated from message chessstreamlive.common.v1.PlayableData
 */
export type PlayableData = Message<"chessstreamlive.common.v1.PlayableData"> & {
  /**
   * solver's position == apply(setup_fen, setup_move); pipeline guarantees equality
   *
   * @generated from field: string fen = 1;
   */
  fen: string;

  /**
   * position BEFORE the opponent's setup move (animate this first)
   *
   * @generated from field: string setup_fen = 2;
   */
  setupFen: string;

  /**
   * the opponent's initiating move, UCI ("e2e4")
   *
   * @generated from field: string setup_move = 3;
   */
  setupMove: string;

  /**
   * plies: [0]=solver, [1]=opponent reply, [2]=solver, …
   *
   * @generated from field: repeated chessstreamlive.common.v1.SolutionStep sequence = 4;
   */
  sequence: SolutionStep[];
};

/**
 * Describes the message chessstreamlive.common.v1.PlayableData.
 * Use `create(PlayableDataSchema)` to create a new message.
 */
export const PlayableDataSchema: GenMessage<PlayableData> = /*@__PURE__*/
  messageDesc(file_common, 1);

/**
 * @generated from message chessstreamlive.common.v1.SolutionStep
 */
export type SolutionStep = Message<"chessstreamlive.common.v1.SolutionStep"> & {
  /**
   * UCI, e.g. "g1f3"
   *
   * @generated from field: string move = 1;
   */
  move: string;

  /**
   * hint for finding THIS move (empty on opponent replies)
   *
   * @generated from field: chessstreamlive.common.v1.PuzzleHint hint = 2;
   */
  hint?: PuzzleHint | undefined;

  /**
   * scoped to THIS position (no global-list ambiguity)
   *
   * @generated from field: repeated chessstreamlive.common.v1.PrecomputedRefutation refutations = 3;
   */
  refutations: PrecomputedRefutation[];
};

/**
 * Describes the message chessstreamlive.common.v1.SolutionStep.
 * Use `create(SolutionStepSchema)` to create a new message.
 */
export const SolutionStepSchema: GenMessage<SolutionStep> = /*@__PURE__*/
  messageDesc(file_common, 2);

/**
 * Semantic / motif hints. The mechanical piece→target→full reveal is derived
 * client-side from `move`, so it is NOT stored.
 *
 * @generated from message chessstreamlive.common.v1.PuzzleHint
 */
export type PuzzleHint = Message<"chessstreamlive.common.v1.PuzzleHint"> & {
  /**
   * soft prompt, e.g. "Can you hit two pieces at once?"
   *
   * @generated from field: string nudge = 1;
   */
  nudge: string;

  /**
   * names the motif, e.g. "Fork"
   *
   * @generated from field: string idea = 2;
   */
  idea: string;
};

/**
 * Describes the message chessstreamlive.common.v1.PuzzleHint.
 * Use `create(PuzzleHintSchema)` to create a new message.
 */
export const PuzzleHintSchema: GenMessage<PuzzleHint> = /*@__PURE__*/
  messageDesc(file_common, 3);

/**
 * @generated from message chessstreamlive.common.v1.PrecomputedRefutation
 */
export type PrecomputedRefutation = Message<"chessstreamlive.common.v1.PrecomputedRefutation"> & {
  /**
   * the wrong move this punishes, UCI
   *
   * @generated from field: string attempted_move = 1;
   */
  attemptedMove: string;

  /**
   * the punishing reply line, UCI plies
   *
   * @generated from field: repeated string refutation_line = 2;
   */
  refutationLine: string[];
};

/**
 * Describes the message chessstreamlive.common.v1.PrecomputedRefutation.
 * Use `create(PrecomputedRefutationSchema)` to create a new message.
 */
export const PrecomputedRefutationSchema: GenMessage<PrecomputedRefutation> = /*@__PURE__*/
  messageDesc(file_common, 4);

/**
 * @generated from message chessstreamlive.common.v1.Taxonomy
 */
export type Taxonomy = Message<"chessstreamlive.common.v1.Taxonomy"> & {
  /**
   * @generated from field: int32 rating = 1;
   */
  rating: number;

  /**
   * @generated from field: repeated string themes = 2;
   */
  themes: string[];

  /**
   * @generated from field: repeated string opening_tags = 3;
   */
  openingTags: string[];

  /**
   * "g:<id>"; empty if imported corpus puzzle
   *
   * @generated from field: optional string source_game_id = 4;
   */
  sourceGameId?: string | undefined;
};

/**
 * Describes the message chessstreamlive.common.v1.Taxonomy.
 * Use `create(TaxonomySchema)` to create a new message.
 */
export const TaxonomySchema: GenMessage<Taxonomy> = /*@__PURE__*/
  messageDesc(file_common, 5);

/**
 * @generated from enum chessstreamlive.common.v1.Color
 */
export enum Color {
  /**
   * @generated from enum value: COLOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLOR_WHITE = 1;
   */
  WHITE = 1,

  /**
   * @generated from enum value: COLOR_BLACK = 2;
   */
  BLACK = 2,
}

/**
 * Describes the enum chessstreamlive.common.v1.Color.
 */
export const ColorSchema: GenEnum<Color> = /*@__PURE__*/
  enumDesc(file_common, 0);

/**
 * @generated from enum chessstreamlive.common.v1.GameResult
 */
export enum GameResult {
  /**
   * @generated from enum value: GAME_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PGN "*"
   *
   * @generated from enum value: GAME_RESULT_ONGOING = 1;
   */
  ONGOING = 1,

  /**
   * PGN "1-0"
   *
   * @generated from enum value: GAME_RESULT_WHITE_WIN = 2;
   */
  WHITE_WIN = 2,

  /**
   * PGN "0-1"
   *
   * @generated from enum value: GAME_RESULT_BLACK_WIN = 3;
   */
  BLACK_WIN = 3,

  /**
   * PGN "1/2-1/2"
   *
   * @generated from enum value: GAME_RESULT_DRAW = 4;
   */
  DRAW = 4,
}

/**
 * Describes the enum chessstreamlive.common.v1.GameResult.
 */
export const GameResultSchema: GenEnum<GameResult> = /*@__PURE__*/
  enumDesc(file_common, 1);

/**
 * Engine quality bucket for ONE played move — the grade a client renders beside
 * the move ("blunder", "brilliant"). Produced by the analysis-server's
 * `classify.rs::classify_move` (win-probability-loss cutoffs plus the best-move
 * short-circuit) and carried to clients on `EvalUpdate.move_class` /
 * `EvalPoint.move_class`.
 *
 * THIRD DECLARATION OF ONE VOCABULARY, deliberately — and the NUMBERING is the
 * trap. `game_analysis.proto`'s `MoveClass` is the producer's spelling, and this
 * enum copies its numbering exactly (BEST = 1 … BOOK = 8) so the relay maps
 * producer → wire without re-ordering. `commentary.proto`'s
 * `CommentaryMoveClass` holds the same eight members in QUALITY order
 * (BOOK = 1 … BLUNDER = 8): same names, DIFFERENT numbers. So never move a value
 * between these files by casting its integer — map by NAME.
 *
 * Why `game_analysis.proto` is not imported here: it is a LEGACY file
 * (unprefixed enum values, `chess.analysis.v1`, on `buf.yaml`'s lint-ignore
 * list) compiled only by tonic-build for analysis-server and protoc-python, and
 * it is not in `:shared`'s Wire sourcePath — importing it would drag a
 * lint-ignored legacy file into every client's dependency graph. That is the
 * same trade `commentary.proto` wrote down for its own twin. The rule-6
 * migration (give that file a package and move its shared enums HERE) is what
 * collapses all three; until someone does it, `MoveClassMirrorTest` pins them
 * member-for-member, and this one number-for-number against the producer.
 *
 * @generated from enum chessstreamlive.common.v1.MoveClass
 */
export enum MoveClass {
  /**
   * @generated from enum value: MOVE_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * top engine choice
   *
   * @generated from enum value: MOVE_CLASS_BEST = 1;
   */
  BEST = 1,

  /**
   * top engine choice involving a material sacrifice
   *
   * @generated from enum value: MOVE_CLASS_BRILLIANT = 2;
   */
  BRILLIANT = 2,

  /**
   * top 2-3 engine choices, but not the absolute best
   *
   * @generated from enum value: MOVE_CLASS_GOOD = 3;
   */
  GOOD = 3,

  /**
   * unnoteworthy, standard play
   *
   * @generated from enum value: MOVE_CLASS_NORMAL = 4;
   */
  NORMAL = 4,

  /**
   * ~2-5% win-probability loss
   *
   * @generated from enum value: MOVE_CLASS_INACCURACY = 5;
   */
  INACCURACY = 5,

  /**
   * ~5-15% win-probability loss
   *
   * @generated from enum value: MOVE_CLASS_MISTAKE = 6;
   */
  MISTAKE = 6,

  /**
   * >15% win-probability loss
   *
   * @generated from enum value: MOVE_CLASS_BLUNDER = 7;
   */
  BLUNDER = 7,

  /**
   * recognized opening theory
   *
   * @generated from enum value: MOVE_CLASS_BOOK = 8;
   */
  BOOK = 8,
}

/**
 * Describes the enum chessstreamlive.common.v1.MoveClass.
 */
export const MoveClassSchema: GenEnum<MoveClass> = /*@__PURE__*/
  enumDesc(file_common, 2);

